import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Call } from '../model';
import { actions, useSelector } from '../store';
import { selectCall, selectLine } from '../store/reducers/janus';
import { BackspaceIcon, PhoneDialIcon, PhoneDialVideoIcon } from './icons';
import InCallControl from './InCallControl';
import Keypad from './Keypad';
import css from './Phone.module.scss';
import PhoneDisplay from './PhoneDisplay';

export default function Phone() {
  const [number, setNumber] = useState('')
  const inputRef = useRef<HTMLInputElement>(null)
  const dispatch = useDispatch()
  const line = useSelector(selectLine)
  const call = useSelector(selectCall)
  const [showStats, setShowStats] = useState(false)


  useEffect(() => {
    console.log('stats have changed')
  }, [call.stats])

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (showStats) {
        dispatch(actions.getCallStats())
      }
    }, 100);

    return () => clearTimeout(timeout);
  });

  function onBackspace() {
    setNumber(number.substr(0, number.length - 1))
  }

  function onDigit(digit: string) {
    setNumber(n => n + digit)
  }

  function shouldShowInCallControl(): boolean {
    if (call == null) { return false }
    return call.canHangUp
  }

  return <div className={css.phone}>
    <PhoneDisplay />

    {shouldShowInCallControl() ? <InCallControl /> : renderDialler()}

    {(call.canHangUp && showStats && call.stats != null) ? <div className={css.statsContainer}>
      {stringifyStats(call)}
    </div> : null}
  </div>

  function renderDialler() {
    return (
      <div>
        <div className={css.number}>
          <input id={css.phoneNumber} ref={inputRef} value={number} onChange={e => setNumber(e.currentTarget.value)} />
          <button className={css.backspace} onClick={onBackspace}>
            <BackspaceIcon />
          </button>
        </div>

        <Keypad onKeyPressed={onDigit} />
        <div className={css.callButtons}>
          {call.canDial && <button disabled={!number} onClick={() => {
            dispatch(actions.toggleVideo(false))
            dispatch(actions.dial(number))
          }}><PhoneDialIcon /></button>}
          {call.canDial && <button disabled={!number} onClick={() => {
            dispatch(actions.toggleVideo(true, 'fhdres'))
            dispatch(actions.dial(number))
          }}><PhoneDialVideoIcon /></button>}
        </div>
      </div>
    )
  }

  function stringifyStats(call: Call): string {
    if (call.stats == null) return ''

    let statsOutput = "";
    call.stats.forEach(report => {
      if (report.type.indexOf('inbound') === -1 && report.type.indexOf('outbound') === -1) return;
      statsOutput += `\r\nReport: ${report.type}\r\nID: ${report.id}\r\n` +
        `Timestamp: ${report.timestamp}\r\n`;

      // Now the statistics for this report; we intentially drop the ones we
      // sorted to the top above
      Object.keys(report).forEach(statName => {
        if (statName !== "id" && statName !== "timestamp" && statName !== "type") {
          statsOutput += `${statName}: ${report[statName]}\n`;
        }
      });
    });
    return statsOutput
  }
}
